import React from 'react';
import PropTypes from 'prop-types';
import { withPrefix } from 'gatsby';

function EdX2ULogo({ height, width }) {
  return (
    <img
      className="footer-logo image-style-none"
      itemProp="logo"
      typeof="foaf:Image"
      style={{ height, width }}
      src={withPrefix('/images/logos/edX_by2U_white.svg')}
      alt="edx footer logo"
      aria-labelledby="edX-logo edX-2U"
      focusable="false"
    />
  );
}

EdX2ULogo.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

EdX2ULogo.defaultProps = {
  height: 67,
  width: 127,
};

export default EdX2ULogo;
